export default {
    name: 'agrotechnical_events',
    serverName: '/api/v1/agrotechnical_events/field_event',
    apiEventsUrl: '/api/v1/agrotechnical_events/field_events/',
    apiEventUrl: '/api/v1/agrotechnical_events/field_event/'
};
